import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-copyright',
  styleUrls: ['copyright.component.scss'],
  templateUrl: './copyright.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule]
})
export class CopyrightComponent {
  params() {
    return {
      year: new Date().getFullYear()
    };
  }
}
